import styled from 'styled-components';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { breakpoints } from '../../foundation/breakpoints/values.js';
import { unit } from '../../foundation/spacing/utils.js';

var Container = styled.header.withConfig({
  displayName: "Container",
  componentId: "sc-1lv9h61-0"
})(["flex:1;display:flex;flex-direction:column;min-width:0;background-color:", ";"], themeGet('colors.background.50'));
var HeadingContainer = styled.div.withConfig({
  displayName: "HeadingContainer",
  componentId: "sc-1lv9h61-1"
})(["display:flex;flex-direction:column;padding-bottom:", ";gap:", ";", "{gap:", ";flex:1;flex-direction:row;align-items:flex-start;padding-bottom:", ";}"], themeGet('spacing.xl'), themeGet('spacing.2xl'), breakpoints.sm, themeGet('spacing.xl'), themeGet('spacing.2xl'));
var Heading = styled.div.withConfig({
  displayName: "Heading",
  componentId: "sc-1lv9h61-2"
})(["display:flex;flex-direction:row;flex-shrink:0;gap:", ";align-items:center;"], unit('lg'));
var Actions = styled.div.withConfig({
  displayName: "Actions",
  componentId: "sc-1lv9h61-3"
})(["display:flex;flex-direction:row;flex-wrap:wrap;gap:", ";", "{flex:1;justify-content:flex-end;}"], themeGet('spacing.lg'), breakpoints.sm);

export { Actions, Container, Heading, HeadingContainer };
